// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Elr3","loaderOuter":"PageOverlayLoader_loaderOuter__3tI9I"};